import createReducer from './createReducer';
import * as actions from '../actions/actionTypes';
import { mergeAll } from 'ramda';
const initialState={
  bankAccountInfo: {
    bankAccountDetails: []
  }
};
const addBankReducer = createReducer(initialState.bankAccountInfo, {
  [actions.ACCOUNT_INFO]: (state, action) => {
    const dt= saveData(state, action);
    return dt;
  }
});

const saveData=(state=initialState.bankAccountInfo, action)=>{
  if(action.payload.type === actions.EXTERNAL_BANK_ACCOUNT_LIST){
    let newState={ ...state };
    if(isEmpty(newState)){
      newState=initialState.bankAccountInfo;
    }
    const list =[...newState.bankAccountDetails];
    list.push(action.payload.bankAccountDetails);
    newState.bankAccountDetails=list;
    return newState;
  }else if(action.payload.type === actions.EXTERNAL_BANK_ACCOUNT_LIST_RESET){
    let newState={ ...state };
    if(isEmpty(newState)){
      newState=initialState.bankAccountInfo;
    }
    const list =[...newState.bankAccountDetails];
    newState.bankAccountDetails=[];
    return newState;
  }else if(action.payload.type === actions.COMPONENT_SWITCH_INFO){
    let newState={ ...state };
    newState.tabs=action.payload.tabs;
    return newState;
  }else{
    return state;
  }
};
const isEmpty=(obj)=>{
  return Object.keys(obj).length===0;
};
export default addBankReducer;
